module.exports = __webpack_public_path__ + "img/star_text_bg@3x.b2bf9e80.png";